import { render, staticRenderFns } from "./NotificationsTriggered.vue?vue&type=template&id=ba0700f2&scoped=true&"
import script from "./NotificationsTriggered.vue?vue&type=script&lang=js&"
export * from "./NotificationsTriggered.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsTriggered.vue?vue&type=style&index=0&id=ba0700f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba0700f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba0700f2')) {
      api.createRecord('ba0700f2', component.options)
    } else {
      api.reload('ba0700f2', component.options)
    }
    module.hot.accept("./NotificationsTriggered.vue?vue&type=template&id=ba0700f2&scoped=true&", function () {
      api.rerender('ba0700f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/alerts/NotificationsTriggered.vue"
export default component.exports